<template>
  <div class="updatePwdInfo" ref="form" :style="{ height: height }">
    <div class="update_title">
      <template v-if="/^1\d{10}$/.test(phoneNumber)">
        <span>{{ $t('为您的账号') }}</span>
        <span class="update_title_text">{{ phoneNumber.substring(0, 3) }}****{{
          phoneNumber.substring(7, 11)
        }}</span>
        <span>{{ $t('设置新密码') }}</span>
      </template>
      <template v-else>
        <span>{{ $t('为您的账号') }}</span>
        <span class="update_title_text">{{ phoneNumber }}</span>
        <span>{{ $t('设置新密码') }}</span>
      </template>
    </div>
    <div v-if="isPwd" class="update_pwd">
      <span class="update_pwd_text">{{ $t('旧密码') }}</span>
      <v-text-field :class="['props-select', 'remove-min-height']" filled flat :label="$t('请输入旧密码')" solo
        validate-on-blur :rules="[rules.pswRequired]" v-model="passwordOld" ref="passwordOld" required
        type="password"></v-text-field>
      <!-- <img class="update_pwd_img" src="imgs/svg/我的/设密码睁眼.svg" /> -->
    </div>
    <div v-else class="update_pwd update_pwd__vcode">
      <span class="update_pwd_text">{{ $t('验证码') }}</span>
      <v-text-field :class="['props-select', 'remove-min-height']" filled flat :label="$t('请输入验证码')" solo
        validate-on-blur :rules="[rules.regcodeRequired]" v-model="regcode" ref="regcode" required></v-text-field>
      <span class="update_pwd__vcode-btn" @click="get_vcode">{{ vcode }}</span>
    </div>
    <div class="update_pwd">
      <span class="update_pwd_text">{{ $t('新密码') }}</span>
      <v-text-field :class="['props-select', 'remove-min-height']" filled flat :label="$t('请输入新密码')" solo
        validate-on-blur :rules="[rules.pswNewRequired, rules.pswComplexityRqmt, rules.pswCannotBeSameAsOld]"
        v-model="passwordNew" ref="passwordNew" required type="password"></v-text-field>
      <!-- <img class="update_pwd_img" src="imgs/svg/我的/设密码睁眼.svg" /> -->
    </div>
    <div class="update_pwd">
      <span class="update_pwd_text">{{ $t('确认密码') }}</span>
      <v-text-field :class="['props-select', 'remove-min-height']" filled flat :label="$t('请确认新密码')" solo
        validate-on-blur :rules="[rules.pswConfirmRequired, rules.pswConfirmMustBeSame]" v-model="passwordCertain"
        ref="passwordCertain" required type="password" @keyup.enter.native="updatePwd"></v-text-field>
      <!-- <img class="update_pwd_img" src="imgs/svg/我的/设密码睁眼.svg" /> -->
    </div>

    <div class="update_pwd_btn" @click="updatePwd">{{ $t('保存新密码') }}</div>
    <div v-if="!isPwd" @click="Change2Pwd" class="update_pwd_change">{{ $t('按旧密码设置') }}</div>
    <div v-else-if="/^1\d{10}$/.test(phoneNumber)" @click="Change2Regcode" class="update_pwd_change">
      {{ $t('按验证码设置') }}
    </div>
    <div v-else-if="/^((?:\w+-*\.?)+)@((?:\w+-*)+(\.(?:\w+-*))+)+$/.test(this.phoneNumber)" @click="Change2Forgot"
      class="update_pwd_change">
      {{ $t('忘记密码') }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import { URLS } from '../util/urls'
import swal from 'sweetalert2'
import msgbus from '../msgBus'
import TipsList from '../config/TipsList'
import tools from '../util/tools'

export default {
  name: 'iDS-UpdatePwd',
  data: function () {
    return {
      phoneNumber: '',
      isRemember: true,
      passwordNew: '',
      passwordOld: '',
      passwordCertain: '',
      regcode: '',
      vcode_disabled: false,
      isPwd: true,
      isRegcode: false,
      regcodeMsg: this.$t('点击下方按钮以获取验证码'),
      vcode: this.$t('获取验证码'),
      times: '',
      formHasErrors: false,
      errorInfo: '',
      rules: {
        pswRequired: v => !!v || this.$t('请输入旧密码'),
        pswNewRequired: v => !!v || this.$t('请输入新密码'),
        pswConfirmRequired: v => !!v || this.$t('请再次输入密码'),
        regcodeRequired: v => !!v || this.$t('请输入验证码'),
        pswComplexityRqmt: v =>
          /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W]+$)\S{8,32}$/.test(v) ||
          this.$t('密码需包含“大写字母、小写字母、数字、特殊符号”中两种以上的组合，且长度在8到32位'),
        pswCannotBeSameAsOld: v =>
          (!!v && v != this.passwordOld) || this.$t('新密码不能与旧密码相同'),
        pswConfirmMustBeSame: v =>
          (!!v && v == this.passwordNew) || this.$t('两次输入密码不一致')
      }
    }
  },

  computed: {
    form() {
      if (this.isPwd) {
        return {
          passwordOld: this.passwordOld,
          passwordNew: this.passwordNew,
          passwordCertain: this.passwordCertain,
        }
      } else {
        return {
          regcode: this.regcode,
          passwordNew: this.passwordNew,
          passwordCertain: this.passwordCertain,
        }
      }
    },
    get_regcode() {
      return this.vcode
    },
    height() {
      return `calc(${window.innerHeight}px - 48px ` + ')'
    },
  },

  methods: {
    updatePwd() {
      var formHasErrors = false
      //检查表单
      Object.keys(this.form).forEach((f) => {
        if (!this.$refs[f].validate(true)) {
          formHasErrors = true
        }
      })
      //有错返回
      if (formHasErrors) {
        return
      }
      this.mUpdatePwd()
    },

    mUpdatePwd() {
      debugHelper.log('修改密码')
      const data = {
        password: this.form.passwordOld,
        newPassword: this.form.passwordNew,
      }
      if (/^1\d{10}$/.test(this.phoneNumber)) {
        data.mobileNo = this.phoneNumber
        data.vcode = this.form.regcode
      } else {
        data.email = this.phoneNumber
      }
      msgbus.vm
        .updateUserPwd({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          data,
          vm: msgbus.vm,
        })
        .then(
          () => {
            debugHelper.log('更新成功')
            swal.fire({
              text: this.$t('修改成功，需要重新登录！'),
              title: this.$t('设置新密码'),
              type: 'success',
              showConfirmButton: false,
              timer: 1500,
            })

            dbHelper.restore()
            // 跳转登录页面
            this.$router.replace({ name: 'pwdlogin' })
          },
          (err) => {
            debugHelper.log('密码修改失败')
            debugHelper.log(err)
            var prefix = err.prefix
            var error = TipsList[prefix + err.response.data.message]
            var errorCN = error ? error.text.cn : err.toString()
            errorCN = errorCN != '' ? this.$t('原因：') + errorCN : errorCN

            swal.fire({
              text: this.$t('密码修改失败') + errorCN,
              title: this.$t('设置新密码'),
              type: 'error',
              showConfirmButton: false,
              timer: 1500,
            })
            return
          }
        )
    },

    formValidate(intelligent = false) {
      Object.keys(this.form).forEach(prop => {
        const ref = this.$refs[prop]
        const val = this[prop]
        if (ref) {
          if (intelligent) { // 先重置校验结果，再校验有值项
            ref.resetValidation()
            if (val) {
              setTimeout(() => {
                ref.validate(true)
              }, 100)
            }
          } else {
            ref.validate(true)
          }
        }
      })
    },

    Change2Regcode() {
      this.isPwd = false
      this.isRegcode = 'notsend'
      this.regcodeMsg = this.$t('点击下方按钮以获取验证码')
      this.formValidate(true)
      this.$nextTick(() => {
        this.formValidate(true)
      })
    },

    Change2Forgot() {
      this.$router.replace({ name: 'resetpwd' })
    },

    Change2Pwd() {
      this.isPwd = true
      this.isRegcode = false
      this.$nextTick(() => {
        this.formValidate(true)
      })
    },
    changeView() {
      msgbus.vm.setTitleList({
        visible: false,
        list: [],
        listIcon: [],
        change: () => { },
        curValue: '',
        curIcon: '',
      })
      msgbus.vm.setTitle(this.$t('设置登录密码'))
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setBackDisabled(false)
    },
    get_vcode() {
      if (this.vcode == this.$t('获取验证码')) {
        return new Promise((resolve, reject) => {
          axios({
            method: 'post',
            url: URLS.EDS_VCODE_URL,
            data: {
              mobileNo: this.phoneNumber,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((resp) => {
              this.vcode_disabled = true
              this.isRegcode = 'send'
              this.regcodeMsg = this.$t('短信验证码已发送，请输入验证码')
              this.vcode = this.$t('重新发送')
              resolve()
            })
            .catch((err) => {
              err.type = 'error'
              err.prefix = 'vcode:'
              tools.showTips(this, err)
              return
            })
        })
      }
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }
    this.phoneNumber = msgbus.vm.getAccountInfo().mobileNo || msgbus.vm.getAccountInfo().email
    this.changeView()
  },
  mounted() { },
}
</script>

<style lang="scss">
.updatePwdInfo {
  background: #ededed;
  padding: 0 20px;

  .update_title {
    padding-top: 20px;
    text-align: center;
    width: 100%;
    min-height: 60px;
    max-height: 80px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: rgba(20, 20, 20, 0.6);
    letter-spacing: 0.72px;
    text-align: center;
    line-height: 22px;
    border-bottom: 1px solid #d7d7d7;
  }

  .update_title_text {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #141414;
    letter-spacing: 0.72px;
    text-align: center;
    line-height: 22px;
  }

  .update_pwd {
    padding: 0;
    position: relative;

    &>.v-input {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        border-bottom: 1px solid #d7d7d7;
      }

      &>.v-input__control {
        &>.v-input__slot {
          padding: 0;
        }

        &>.v-text-field__details {
          padding: 0;
        }
      }
    }

    &>.update_pwd__vcode-btn {
      font-size: 14px;
      color: #3085d6;
      white-space: nowrap;
      border: 1px solid #3085d6;
      border-radius: 2px;
      padding: 0 8px;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .props-select {
    padding: 0;
    margin: 0;
    width: calc(100% - 80px);
    display: inline-block;

    &.multiple-select {
      .v-select__selections {
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        min-height: 0px;

        &>input {
          width: 0px;
        }

        .v-chip--select-multi {
          margin: 0px 4px 0px 0px;

          .v-chip__content {
            height: 1.5rem;
          }
        }

        .v-select__selection--comma {
          font-size: 1rem;
          margin: 0;
          position: inherit !important;
        }
      }
    }

    .v-input__control {
      .v-input__slot {
        margin: 0;

        input {
          padding: 0;
        }

        .v-select__selection--comma {
          font-size: 1rem;
          text-align: right;
          position: absolute;
          margin: 0;
          right: 1.2rem;
        }

        .v-input__append-inner {
          width: 1.2rem;
          height: 1.2rem;
          padding: 0;

          .v-input__icon--append {
            width: 1.2rem;
            height: 1.2rem;

            i {
              font-size: 1.7rem;
              width: 1.2rem;
              height: 1.2rem;
            }
          }
        }

        .v-text-field__suffix {
          font-size: 1.1rem;
        }
      }

      .v-text-field__details {
        margin: 0;
      }
    }
  }

  .remove-min-height {
    min-height: 0;
    padding: 0 0rem 0 0;
    margin: 0px;

    .v-input__control {
      min-height: 0px;
    }
  }

  .update_pwd_text {
    display: inline-block;
    height: 50px;
    line-height: 46px;
    font-family: PingFangSC-Regular;
    vertical-align: middle;
    font-size: 16px;
    color: #323232;
    letter-spacing: 0.77px;
    text-align: left;
    width: 80px;
  }

  .update_pwd_input {
    width: 50%;
    display: inline-block;
    height: 48px;
    line-height: 48px;
    vertical-align: middle;
  }

  .update_pwd_img {
    height: 48px;
    width: 22px;
    vertical-align: middle;
    float: right;
  }

  .update_pwd_info {
    margin-top: 10px;
    margin-left: 5%;
    opacity: 0.4;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #323232;
    letter-spacing: 0.77px;
  }

  .update_pwd_btn {
    margin-top: 35px;
    height: 44px;
    line-height: 44px;
    background-color: rgb(48, 133, 214);
    border-radius: 4px;
    border-radius: 4px;
    opacity: 0.6;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 0.77px;
    text-align: center;
  }

  .update_pwd_change {
    margin-top: 30px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgb(48, 133, 214);
    letter-spacing: 0.18px;
    text-align: center;
  }

  .v-input__slot {
    margin-bottom: 0px;
    border-width: thin;
  }

  .v-text-field {
    margin-bottom: 2px;
    height: 48px;
    vertical-align: middle;
  }

  .v-text-field__details {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .v-text-field--solo>.v-input__control>.v-input__slot {
    margin-top: 14px;
    background: #ededed;
  }

  .v-label {
    font-size: 16px;
  }

  input {
    margin-top: 0px !important;
    padding: 6px 0;
  }

  button.v-btn.updatePwd {
    width: calc(100% - 16px);
  }

  .get_regcode {
    float: right;
    margin-top: -72px;
    margin-right: 20px;
    width: auto !important;
  }

  .forgot {
    float: right;
    margin-right: 5%;
    margin-top: 0px;
    padding-top: 4px;
    color: blue;
    font-size: 1.1rem;
    margin-bottom: 0px;
  }
}
</style>
